(() => {
  const ENDPOINT = 'https://manage.kmail-lists.com/ajax/subscriptions/subscribe';
  const LIST_ID = 'RamM7S';
  const NEWSLETTER_TAG = 'newsletter';

  function isNewsletterForm(form) {
    const tags = form.querySelector('input[name="contact[tags]"]');
    const email = form.querySelector('input[name="contact[email]"]');
    return Boolean(tags && email && tags.value.toLowerCase().split(',').map((tag) => tag.trim()).includes(NEWSLETTER_TAG));
  }

  function sourceName(form) {
    if (form.id === 'ContactFooter') return 'National Park Magic footer newsletter';
    const section = form.closest('[id^="shopify-section-"]');
    return section ? `National Park Magic ${section.id} newsletter` : 'National Park Magic newsletter';
  }

  function subscriptionData(form, email) {
    return new URLSearchParams({
      g: 'RamM7S',
      email,
      '$fields': '$source,NPM Signup Form,NPM Signup Page URL',
      '$source': sourceName(form),
      'NPM Signup Form': sourceName(form),
      'NPM Signup Page URL': window.location.href,
    });
  }

  async function subscribe(form, email) {
    const controller = new AbortController();
    const timeout = window.setTimeout(() => controller.abort(), 5000);
    try {
      const response = await fetch(ENDPOINT, {
        method: 'POST',
        headers: {
          'content-type': 'application/x-www-form-urlencoded',
        },
        body: subscriptionData(form, email),
        keepalive: true,
        signal: controller.signal,
      });
      if (!response.ok) {
        throw new Error(`Klaviyo subscription failed (${response.status})`);
      }
      const result = await response.json();
      if (!result.success) throw new Error('Klaviyo subscription was not accepted');
    } finally {
      window.clearTimeout(timeout);
    }
  }

  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !isNewsletterForm(form) || form.dataset.npmKlaviyoSubmitting === 'true') return;

    const emailInput = form.querySelector('input[name="contact[email]"]');
    if (!emailInput || !emailInput.validity.valid) return;

    event.preventDefault();
    form.dataset.npmKlaviyoSubmitting = 'true';
    const submit = form.querySelector('[type="submit"]');
    if (submit) submit.disabled = true;

    try {
      await subscribe(form, emailInput.value.trim());
    } catch (error) {
      console.warn('[NPM newsletter] Klaviyo bridge failed; preserving Shopify signup.', error);
    }

    HTMLFormElement.prototype.submit.call(form);
  }, true);

  window.NPMKlaviyoNewsletter = { LIST_ID, isNewsletterForm, subscriptionData };
})();
